export const ERROR_MESSAGES = [
  { id: 1, value: "Try again." },
  {
    id: 2,
    value:
      "Too many unsuccessful login attempts. Please try again in a few minutes."
  }
];
